import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-settings-home',
  templateUrl: './settings-home.component.html',
  styleUrls: ['./settings-home.component.scss'],
})
export class SettingsHomeComponent implements OnInit {
  success: any;
  error: any;
  selectedMenu: string;
  selectedName: string;
  constructor(private location: Location, private router: Router) {
    this.selectedMenu = 'notifications';
  }
  menus = [
    {
      id: 'notifications',
      name: 'Notification Setting',
      // 'permissionId': 'E_WALLET_ACCOUNTS',
    },
  ];

  selectMenu(id: string, name: string) {
    this.selectedMenu = id;
    this.selectedName = name;
    this.router.navigateByUrl(
      `/admin/setting/application-security/settings/${id}`
    );
  }
  ngOnInit(): void {}

  goBack() {
    this.router.navigateByUrl('/admin/setting/application-security');
  }
}
